// Angular
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CommonUtilitiesService {
  private actionRefresh = new BehaviorSubject<any>({});
  refresh = this.actionRefresh.asObservable();
  constructor(
    private router: Router,
  ) { }

  refreshPrecalificationData(value = false): void {
    localStorage.setItem("iniciaPreca", "");
    localStorage.setItem("moduleTitle", "");
    localStorage.setItem("moduleSubtitle", "");
    localStorage.setItem("codeudor", "");
    this.actionRefresh.next(value);
  }
}
